<template>
	<section>
		<div
			class="shadow-box section-content"
			:class="{'with-shadow' : !$mq.isDesktop()}"
		>
			<h2
				v-html="`Condividi Quomi`"
			/>
			<template
				v-if="!loading"
			>
				<progressive-image
					:src="require('../../assets/img/covers/invite-friend.jpg')"
					:ratioWidth="2"
					:ratioHeight="1"
				/>
				<div
					class="label"
					v-html="`Ricevi <b>${ rewardAmount * rewardCount } €</b> per ogni amico che inviti`"
				/>

				<router-link :to="{ name: 'profile_invite-friend' }">
					<CTA
						:content="`Scopri di più`"
						:size="`small`"
					/>
				</router-link>
			</template>
			<loading-placeholder
				v-if="loading"
			/>
		</div>
	</section>
</template>

<script>
import CTA from '../Elements/CTA'

import { configStore } from '../../store/configStore' 

export default {
	components: {
		CTA
	},

	data () {
		return {
			configStore: configStore.state
		}
	},
	computed: {
		loading () {
			return this.configStore.loading
		},

		rewardAmount () {
			return this.configStore.config && this.configStore.config['quomi.refer.reward_amount']
				? this.configStore.config['quomi.refer.reward_amount']
				: this.configStore.default.reward_amount
		},

		rewardCount () {
			return this.configStore.config && this.configStore.config['quomi.refer.reward_count']
				? this.configStore.config['quomi.refer.reward_count']
				: this.configStore.default.reward_amount
		},
	},

	mounted () {
		configStore.loadConfig()
	}
}

</script>

<style scoped>
.shadow-box {
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	height: 95%;
}

section >>> .image {
	padding-bottom: 50%;
	margin-bottom: 5px;
}

.label {
	margin-bottom: 10px;
}

.image img {
	position: abolute;
	top: 0;
	left: 0;
}

a {
	margin: 0 auto;
	min-width: 170px;
	margin-top: auto;
	width: 100%;
}

.btn {
	width: 100%;
}
</style>
